module Client.Styles
open Feliz
open Feliz.MaterialUI

let dexRed = "#EE2030"

type SiteClasses =
  { root : string
    appBar : string
    appBarShift : string
    menuButton : string
    hide : string
    drawer : string
    drawerPaper : string
    drawerHeader : string
    standAloneContent : string
    content : string
    contentShift : string
    nestedMenuItem : string
    toolbar : string    
    buttonProgress : string
    wrapper : string
    timelineOppositeContent : string }

let useStyles = 
  Styles.makeStyles(fun (styles : StyleCreator<unit>) (theme : Theme) ->
    let drawerWidth = 240
    {
      root = styles.create [
        style.display.flex
      ]
      appBar = styles.create [
        style.zIndex (theme.zIndex.drawer + 1)
      ]
      appBarShift = styles.create [
        style.width (length.calc (sprintf "(100%% - %ipx)" drawerWidth))
        style.marginLeft drawerWidth
      ]
      menuButton = styles.create [
        style.marginRight (theme.spacing 2)
      ]
      hide = styles.create [
        style.display.none
      ]
      drawer = styles.create [
        style.width (length.px drawerWidth)
        style.flexShrink 0  // TODO: Does this do anything?
      ]
      drawerPaper = styles.create [
        style.width (length.px drawerWidth)
      ]
      drawerHeader = styles.create [
        style.display.flex
        style.alignItems.center
        style.padding (theme.spacing(0,1))
        // necessary for content to be below app bar
        yield! theme.mixins.toolbar
        style.justifyContent.flexEnd
      ]
      content = styles.create [
        style.width 0  // TODO: is there a better way to prevent long code boxes extending past the screen?
        style.flexGrow 1
        style.padding (theme.spacing 3)
        style.marginLeft (drawerWidth * -1)
      ]
      standAloneContent = styles.create [
        style.flexGrow 1
        style.padding (theme.spacing 3)
        style.marginLeft 0
      ]
      contentShift = styles.create [
        style.marginLeft 0
      ]
      nestedMenuItem = styles.create [
        style.paddingLeft (theme.spacing 4)
      ]
      toolbar = styles.create [
        style.display.flex
        style.alignItems.center
        style.justifyContent.flexEnd
        style.padding (theme.spacing(0,1))
        yield! theme.mixins.toolbar
      ]          
      buttonProgress = styles.create [
        style.color (Colors.green.``500``)
        style.position.absolute
        style.top (length.percent 50)
        style.left (length.percent 50)
        style.marginTop -12
        style.marginLeft -12
      ]
      wrapper = styles.create [
        style.margin (theme.spacing 0)
        style.position.relative
      ]
      timelineOppositeContent = styles.create [
        style.flexBasis (0.2)
        style.flexGrow (0)
        style.flexShrink (0)
      ]
    }
  )